<template>
  <div class="conBox">
    <div class="backgrBox dip fdcolmun">
      <h2>{{ $fanyi("你准备好开始进口了吗？") }}</h2>
      <p>
        {{ $fanyi("现在注册，加入我们的社区。") }}
      </p>
      <el-button
        class="bgYellowBtn register"
        @click="$fun.routerToPage('/Registrati')"
        >{{ $fanyi("注册") }}</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  computed: {},

  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.conBox {
  background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512115300193496.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  height: 424px;
  .backgrBox {
    height: 100%;

    color: var(--Base-White, #fff);
    h2 {
      font-size: 36px;
      font-weight: 700;
      line-height: 44px; /* 122.222% */
      letter-spacing: -0.72px;
      margin-bottom: 20px;
    }
    p {
      font-size: 20px;
      line-height: 30px; /* 150% */
      margin-bottom: 32px;
    }
    .register {
      width: 292px;
      height: 60px;
      padding: 16px 22px;
      font-size: 18px;
      font-weight: 700;
    }
  }
}
</style>
